const MOCK_WORKER_PATH = "/mockServiceWorker.js";

type WorkerRegistration = Pick<
  ServiceWorkerRegistration,
  "active" | "waiting" | "installing" | "unregister"
>;

type WorkerContainer = Pick<ServiceWorkerContainer, "controller" | "getRegistrations">;

export interface MockWorkerRetirement {
  controlled: boolean;
  unregistered: number;
}

export function canUseMockApi(mode: string, enabled: string | undefined, hostname: string): boolean {
  return mode === "mock" && enabled === "1" && isLoopbackHostname(hostname);
}

export async function retireMockServiceWorkers(container: WorkerContainer): Promise<MockWorkerRetirement> {
  const controlled = isMockWorker(container.controller);
  const registrations = await container.getRegistrations();
  const mockRegistrations = registrations.filter(isMockRegistration);
  const results = await Promise.all(mockRegistrations.map((registration) => registration.unregister()));
  return {
    controlled,
    unregistered: results.filter(Boolean).length
  };
}

function isMockRegistration(registration: WorkerRegistration): boolean {
  return [registration.active, registration.waiting, registration.installing].some(isMockWorker);
}

function isMockWorker(worker: Pick<ServiceWorker, "scriptURL"> | null): boolean {
  if (!worker) return false;
  try {
    return new URL(worker.scriptURL).pathname === MOCK_WORKER_PATH;
  } catch {
    return false;
  }
}

function isLoopbackHostname(hostname: string): boolean {
  const normalized = hostname.trim().toLowerCase();
  if (normalized === "localhost" || normalized.endsWith(".localhost")) return true;
  if (normalized === "::1" || normalized === "[::1]") return true;
  const octets = normalized.split(".");
  return octets.length === 4
    && octets[0] === "127"
    && octets.every((octet) => /^\d{1,3}$/.test(octet) && Number(octet) <= 255);
}
